import type { PolicyId } from '../../content/legal/types';

/** Page-specific footer panel + wordmark palette id */
export type FooterTheme =
  | 'home'
  | 'blog'
  | 'careers'
  | 'pricing'
  | 'developers'
  | 'default'
  | PolicyId
  | 'about'
  | 'faq';

export type FooterBrandMarkVariant = Exclude<FooterTheme, 'developers' | 'default'>;

export function footerThemeToBrandMarkVariant(theme: FooterTheme): FooterBrandMarkVariant {
  if (theme === 'developers' || theme === 'default') return 'home';
  return theme;
}
